import { cva } from "../../styled-system/css";

export const pageTitle = cva({
  base: {
    fontSize: '20px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
});

export const titleWrapper = cva({
  base: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    mb: '20px',
  }
});

export const sectionWrapper = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    backgroundColor: 'surface.primary',
    border: '1px solid',
    borderRadius: '8px',
    borderColor: 'border.secondary',
    padding: '24px',
    position: 'relative',
    width: '100%',
  }
});

export const sectionTitle = cva({
  base: {
    fontSize: '18px',
    fontWeight: 'bold',
  }
});